import { environment } from './environments/environment';
import { Auth } from '@aws-amplify/auth';

Auth.configure({
  region: environment.region,
  userPoolId: environment.userPoolId,
  userPoolWebClientId: environment.userPoolClientId,
  mandatorySignIn: true,
  oauth: {
    domain: environment.cognitoDomain,
    scope: environment.scope,
    redirectSignIn: environment.redirectSignIn,
    redirectSignOut: environment.redirectSignOut,
    responseType: environment.responseType,
  },
});
